module.exports = __webpack_public_path__ + "img/64.81effb7c.jpg";